import gql from 'graphql-tag';

const resendVerificationEmail = gql`
  mutation resendVerificationEmail($email: String!) {
    resendVerificationEmail(email: $email)
  }
`;

export default resendVerificationEmail;
